import { IAdminAuthRequest } from "../entities-generated/models/admin-auth/admin-auth-request";
import { IAdminAuthResponse } from "../entities-generated/models/admin-auth/admin-auth-response";
import { AuthApiClient } from "./auth-api-client";

class AdminAuthApiClientClass {
  public adminAuth(endpoint: string, request: IAdminAuthRequest) {
    return AuthApiClient.post<IAdminAuthResponse>(endpoint, request);
  }
}

export const AdminAuthApiClient = new AdminAuthApiClientClass();